export const required = (input: string) => `${input} est un champ requis`;
export const invalid = (input: string) => `${input} n'est pas valide`;

/** Re-exported so front-office schemas keep a single source for Zod 4 type-issue messages. */
export { buildTypeIssueMessage } from "@asap/shared/schemas/shared";
